import type React from 'react';

import { Breadcrumbs } from '@change/ds-core-ui/Breadcrumbs';

import { useCategoryBreadcrumbs } from './hooks';

export const CategoryBreadcrumbs: React.FC<EmptyProps> = () => {
	const {
		data: { items },
	} = useCategoryBreadcrumbs();

	return <Breadcrumbs data-qa="breadcrumb-navigation" items={items} maxVisibleTablet={3} />;
};
